import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { landingRoute } from '~/utils/constants/routes';

type Props = {};

const NotFoundPage = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div className='min-h-screen bg-white dark:bg-lumi-dark-300 flex items-center justify-center px-4'>
      <div className='text-center'>
        {/* Glow */}
        <div className='relative mx-auto mb-8 w-fit'>
          <div className='absolute inset-0 blur-[60px] bg-lumi-600/30 rounded-full' />
          <span className='relative text-[120px] sm:text-[160px] font-bold bg-gradient-to-r from-lumi-400 to-lumi-cyan-400 bg-clip-text text-transparent leading-none'>
            404
          </span>
        </div>

        <h1 className='text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-4'>
          {t('notFound.title')}
        </h1>
        <p className='text-gray-500 dark:text-white/50 text-base mb-10 max-w-sm mx-auto leading-relaxed'>
          {t('notFound.description')}
        </p>

        <Link
          to={landingRoute.home}
          className='inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-lumi-600 hover:bg-lumi-500 text-white font-semibold transition-all duration-200 hover:shadow-xl hover:shadow-lumi-600/40 hover:-translate-y-0.5'
        >
          <svg className='w-4 h-4' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M10 19l-7-7m0 0l7-7m-7 7h18' />
          </svg>
          {t('common.backToHome')}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
